export default __webpack_public_path__ + "static/media/08-3.dc181fdd.jpg";